import Parameter from "./Parameter";
import { DefElement, getDefs, getProperty, IDefObject } from "csi/utility/defUtility";

class Request implements IDefObject {
	m_module: string;
	m_operation: string;
	m_parameters?: Parameter[];

	isValid(): boolean {
		return !!this.m_module && !!this.m_operation;
	}

	constructor(element?: DefElement) {
		this.m_module = getProperty(element, "Module");
		this.m_operation = getProperty(element, "Operation");
		this.m_parameters = getDefs(element, "Parameter", (element: Element) => new Parameter(element)) as Parameter[];
	}
}

export = Request;
